import { Event } from "../domains";
import { SdkConfig } from "../globals";
import { defaultApiClient } from "../libs";

export const collect = async (client, event) => {
  const eventPayload = createEvent(client, event)
  const delegator = SdkConfig.config.delegateCollector?.collect
  if (delegator) {
    delegator(eventPayload)
    return
  }
  return await defaultApiClient.post(`/collect`, eventPayload);
}

export const updateUser = async (client, userAttr) => {
  const payload = {
    clientId: client.get('clientId'),
    serviceId: client.get('serviceId'),
    userId: client.get('userId'),
    attributes: {
      ...userAttr,
      ...client.get('environment'),
      platform: userAttr.platform || 'WEB',
    }
  }
  const delegator = SdkConfig.config.delegateCollector?.collectUser
  if (delegator) {
    await defaultApiClient.post(`/collect/user`, payload)
    delegator({
      attributes: {
        ...userAttr,
        ...client.get('environment'),
        platform: 'APP',
      }
    })
  }
  return await defaultApiClient.post(`/collect/user`, payload)
}

export const collectExposure = async (client, campaignId, $reference, variantKey = undefined) => {
  const payload = {
    $reference,
    timestamp: new Date().getTime(),
    clientId: client.get('clientId'),
    userId: client.get('userId'),
    serviceId: client.get('serviceId'),
    campaignId: campaignId,
    environment: client.get('environment'),
    referrer: location.href,
  }
  if (variantKey !== undefined && variantKey !== null) {
    payload.variantKey = String(variantKey)
  }
  return await defaultApiClient.post(`/collect/exposure`, payload);
}

export const collectInflow = async (client, campaignId, $reference, variantKey = undefined) => {
  const payload = {
    $reference,
    timestamp: new Date().getTime(),
    clientId: client.get('clientId'),
    userId: client.get('userId'),
    serviceId: client.get('serviceId'),
    campaignId: campaignId,
    environment: client.get('environment'),
    referrer: location.href,
  }
  if (variantKey !== undefined && variantKey !== null) {
    payload.variantKey = String(variantKey)
  }
  return await defaultApiClient.post(`/collect/inflow`, payload);
}

const createEvent = (client, event) => {
  return new Event({
    client: {
      clientId: client.get('clientId'),
      serviceId: client.get('serviceId'),
      userId: client.get('userId'),
      sessionId: client.get('sessionId'),
      sdk: {
        webVersion: "v20251113.1"
      },
    },
    environment: client.get('environment'),
    event: {
      ...event,
      pageUrl: location.href,
      referrer: document.referrer,
      timestamp: new Date().getTime(),
    }
  })
}
